import { Component } from '@angular/core';
import { MembershipFormData } from "../membership-form-data/membership-form-data";
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideDownload } from '@ng-icons/lucide';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas-pro';

@Component({
  selector: 'app-my-application-form',
  standalone: true,
  imports: [
    MembershipFormData,
    ...HlmButtonImports,
    NgIcon
  ],
  providers: [provideIcons({ lucideDownload })],
  templateUrl: './my-application-form.html',
})
export class MyApplicationForm {
  downloadPDF(): void {
    const data = document.getElementById('pdfContent');
    if (!data) return;

    // Use a higher scale for better resolution and ensure fonts are rendered correctly
    html2canvas(data, {
      scale: 3,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
      windowWidth: 1200 // Fixed width for consistent layout during capture
    }).then(canvas => {
      const imgWidth = 210; // A4 width in mm
      const pageHeight = 297; // A4 height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      const contentDataURL = canvas.toDataURL('image/jpeg', 1.0);
      const pdf = new jsPDF('p', 'mm', 'a4');

      let heightLeft = imgHeight;
      let position = 0;

      // First page
      pdf.addImage(contentDataURL, 'JPEG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
      heightLeft -= pageHeight;

      // Additional pages
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(contentDataURL, 'JPEG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
        heightLeft -= pageHeight;
      }

      pdf.save('application-form.pdf');
    }).catch(err => {
      console.error('PDF Generation Error:', err);
    });
  }
}
